import type { FaireProductEntity } from "../../entity_types/product";

export const p_c2zuqj6h9b: FaireProductEntity = {
  token: "p_c2zuqj6h9b",
  type: "product",
  name: "RAINBOW ROW-MAHJONG MAT",
  brandToken: "b_xhn8v8jpht",
  brandName: "Rebecca Illustrated",
  imageUrl:
    "https://cdn.faire.com/fastly/e2975e3dfbc0fb58d7af5b2e45a2a68d505ac2c3bc35c5d12fdc73186a32f7f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de974190466ece32ea899b8c45a6ac64492720c8fd646dcef50074ad2ef2d242.webp",
  ],
  priceDollars: 65,
  description:
    "Add charm and artistry to your game night with the Rebecca Illustrated Mahjong Mat, featuring original hand-painted artwork inspired by classic Southern architecture and breezy coastal style.\n\nThis luxury mahjong mat showcases pastel pink and blue homes framed by palm trees, layered with playful scallops, dots, and soft borders that feel timeless and joyful. Designed to protect your table while elevating your setup, it transforms mahjong into a beautiful visual experience.\n\nPerfect for hosting, gifting, or upgrading your own game collection, this mat blends function and fine art, a signature of Rebecca Illustrated’s distinctive style.\n\nMATERIAL: Polyester Fabric with non slip rubber backing\n\nSIZE: 32inx32in\n\nPACKAGING: Rolled in a plastic sleeve\n\n✨ Why you’ll love it:\n\n * Original artwork hand-painted by Rebecca Illustrated\n\n * Soft, durable surface ideal for mahjong tiles\n\n * Protects tables while adding a decorative focal point\n\n * Perfect for mahjong nights, hostess gifts, and game rooms\n\nA must-have for mahjong lovers who appreciate elegant design, Southern charm, and thoughtful details.\n",
  tags: [],
  msrpDollars: 120,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:41.608Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
